import { render, staticRenderFns } from "./TheButton.vue?vue&type=template&id=07921c3b&scoped=true&"
var script = {}
import style0 from "./TheButton.vue?vue&type=style&index=0&id=07921c3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07921c3b",
  null
  
)

export default component.exports